import { Component, OnInit, Input } from '@angular/core';
import { WMAIApiService, Experience, AppInformationService } from '../../core';
import { WgisService } from '../../wgis/wgis.service';
import { Angulartics2 } from 'angulartics2';
import { TranslateService } from '@ngx-translate/core';
import { ModalSize, SuiModalService } from 'ng2-semantic-ui';
import { SimpleModal } from 'src/app/core/templates';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-esperienza-profile',
  templateUrl: './esperienza-profile.component.html',
})
export class EsperienzaProfileComponent implements OnInit {

  @Input() esperienza: Experience;
  isMobile: boolean = false;
  connectionStatus: boolean = true;
  
  constructor(
    private wmaiservice: WMAIApiService,
    private wgisservice: WgisService,
    private angulartics2: Angulartics2,
    private appservice: AppInformationService,
    private translateService: TranslateService,
    private modalService: SuiModalService
  ) {
    this.isMobile = this.appservice.iAmMobile();
    this.connectionStatus = appservice.getCurrentConnectionStatus();
    this.angulartics2.eventTrack.next({ 
      action: 'onShare', 
      properties: {label : 'EsperienzaProfileShare' },
    });

    this.angulartics2.eventTrack.next({ 
      action: 'onMouseEnter', 
      properties: {label : 'EsperienzaProfileMouseEnter' },
    });
  }


  onShare(){
    this.wmaiservice.share(this.esperienza['id']).subscribe(data => {
      if(data.length == 0){
        this.showSimpleModal('modal.esperienza.like.title','modal.esperienza.like.need_login');
      } else if(data.share == '-1'){
        this.showSimpleModal('modal.esperienza.like.title','modal.esperienza.like.limit');
      } else {
        this.esperienza.share = data.share
      }
    }, error => {
      this.showSimpleModal('modal.esperienza.like.title','modal.esperienza.like.error');
    })
  }

  showSimpleModal(title: string, content: string){
    let titlec: string = this.translateService.instant(title);
    let contentc: string = this.translateService.instant(content);
    this.modalService
      .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
      .onApprove(() => {
      })
  }

  ngOnInit(){
    window.scrollTo(0, 0);
  }

  // onMouseEnter(idscheda: number){
  //   this.wgisservice.showSchedaIntenseById(idscheda);
  // }
}
